module.exports = __webpack_public_path__ + "media/images/logos/ncce-logo-white-7ff6c51be2d842666889d40bfcf326b2.svg";